import { Grid } from '@material-ui/core';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

import Logo from 'Elements/Theme/Logo/Logo';

import background from './Auth/background.png';

const LoginGrid = styled(Grid)`
  height: 100%;
  background-color: ${props => props.theme.palette.primary.dark};
`;
const CenterGrid = styled(Grid)`
  ${props => props.theme.breakpoints.down('xs')} {
    flex-direction: column-reverse;
    height: 100%;
  }
`;
const LoginBox = styled(Grid)`
  flex-basis: 380px;
  background-color: ${props => props.theme.palette.background.default};

  ${props => props.theme.breakpoints.down('xs')} {
    flex: 20;
  }
`;
const HeroBox = styled(Grid)`
  padding: 50px;
  background-image: url(${background});
  background-size: cover;
  background-position: center;
  background-color: ${props => props.theme.palette.primary.main};
`;

type Props = {
  children: ReactNode;
};

export default function GuestShell({ children }: Props) {
  return (
    <LoginGrid container justify="center" alignItems="center">
      <CenterGrid
        item
        container
        xs={12}
        sm={11}
        md={10}
        lg={7}
        xl={5}
        wrap="nowrap"
      >
        <LoginBox item container>
          {children}
        </LoginBox>
        <HeroBox item xs container justify="flex-end">
          <Logo />
        </HeroBox>
      </CenterGrid>
    </LoginGrid>
  );
}
